import { VerifiedClient } from '../../../types';

export const isPastTargetDate = (): boolean => {
    const currentYear = new Date().getFullYear();
    return currentYear > 2024;
};

export const getAutoFailReasons = (client: VerifiedClient): string[] => {
    const fraudCheck = client.clientIdFraudCheck;
    const failureReasons = [];
    
    if (fraudCheck?.expiredCheck === 'FAIL') {
        failureReasons.push('Document Expired.');
    }
    if (fraudCheck?.screenCheck === 'FAIL') {
        failureReasons.push('Image is of an ID on a screen.');
    }
    if (fraudCheck?.photocopyCheck === 'FAIL') {
        failureReasons.push('Image is of a photocopied ID.');
    }
    
    return failureReasons;
};

export const isScoreAlreadyZero = (client: VerifiedClient): boolean => {
    const score = client.clientIdFraudCheck?.score;
    return score === '0%' || score === '0';
};
